export default {
  extractData(data, props) {
    let json

    try {
      json = JSON.parse(data)
    } catch (e) {
      json = data
    }

    return _.zipObjects(
      props.map(prop => {
        return { [prop]: json[prop] }
      })
    )
  },

  extractObservables(props) {
    const observables = Object.entries(props).map(key_value_pair => {
      const key = key_value_pair[0]
      const val = key_value_pair[1]

      if (ko.isObservable(val) || !!val.__ko_mapping__ || _.isString(val))
        return { [key]: val }
    })

    return _.chain(observables).compact().zipObjects().value()
  },

  toggleRowVisibility(event, callback) {
    event.preventDefault()

    const $target = $(event.target)

    // Don't expand the row if an action button, like delete, was clicked
    if($target.hasClass('action-btn') || $target.parents().hasClass('action-btn'))
      return false

    $target.parents('.collapsed, .expanded')
      .toggleClass('collapsed expanded')
      .find('.js-collapse')
      .collapse('toggle')
  }
}
